import React from 'react';
import { Col, Container, Row } from 'reactstrap';

const Footer = () => {

    // Get version from environment variable (set in .env file)
    const version = process.env.REACT_APP_VERSION || '1.0.0';
    
    return (
        <React.Fragment>
            <footer className="footer">
                <Container fluid>
                    <Row>
                        <Col sm={6}>
                            {new Date().getFullYear()} © Qdos.
                        </Col>
                        <Col sm={6}>
                            <div className="text-sm-end d-none d-sm-block">
                                <p>{version}</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;